<template>
  <azcon-collection-card-skeleton v-if="loading"/>

  <router-link v-else :to="{ name: 'user.collection-detail', params: { id: collection.id } }"
               class="azcon-collection-card">
    <div :style="coverStyle" class="azcon-collection-card__cover"></div>
    <p v-if="collection.name" class="azcon-collection-card__name">{{ collection.name }}</p>
  </router-link>
</template>

<script>
import AzconCollectionCardSkeleton from "./AzconCollectionCardSkeleton.vue";

export default {
  name: "AzconCollectionCard",
  components: { AzconCollectionCardSkeleton },
  props: {
    collection: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    coverStyle() {
      const url = this.collection.cover_image_link || this.collection.photo_link || this.collection.cover_image || this.collection.image;
      if (!url) return {};
      return {
        backgroundImage: `url(${url})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.azcon-collection-card {
  display: block;
  width: 160px;
  flex-shrink: 0;
  border-radius: 8px;
  background-color: #fff;
  text-decoration: none;
  overflow: hidden;
  border: 1px solid #e8ecf1;

  &__cover {
    width: 100%;
    aspect-ratio: 16 / 10;
    background-color: #f1f5f9;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &__name {
    margin: 0;
    padding: 6px 8px;
    font-size: 12px;
    font-weight: 600;
    color: #4a5c71;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
